<template>
  <v-flex xs12>
    <v-title>Address</v-title>
    <v-card>
      <v-layout row wrap class="ma-1">
        <v-flex xs4 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="address"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.address"
              label="Address"
              :error-messages="errors"
              data-vv-name="address"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs4 class="px-1">
          <ValidationProvider v-slot="{ errors }" name="city" rules="required">
            <v-text-field
              v-model="editableDealerManager.city"
              label="City"
              :error-messages="errors"
              data-vv-name="city"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs2 class="px-1">
          <ValidationProvider v-slot="{ errors }" name="state" rules="required">
            <v-select
              :items="states"
              label="State"
              v-model="editableDealerManager.state"
              :error-messages="errors"
              data-vv-name="state"
              required
            ></v-select>
          </ValidationProvider>
        </v-flex>
        <v-flex xs2 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="postcode"
            rules="required"
          >
            <v-text-field
              type="number"
              v-model="editableDealerManager.postcode"
              label="PostCode"
              :error-messages="errors"
              data-vv-name="postcode"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>
<script>
export default {
  name: 'edit-address-details',
  props: {
    dealerManager: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      states: [
        { text: 'QLD', value: 'QLD' },
        { text: 'NSW', value: 'NSW' },
        { text: 'ACT', value: 'ACT' },
        { text: 'TAS', value: 'TAS' },
        { text: 'SA', value: 'SA' },
        { text: 'VIC', value: 'VIC' },
        { text: 'NT', value: 'NT' },
        { text: 'WA', value: 'WA' },
      ],
    };
  },
  computed: {
    editableDealerManager: {
      get() {
        return this.dealerManager;
      },
      set(val) {
        this.$emit('update:dealerManager', val);
      },
    },
  },
};
</script>
